const en_trans_returnsuplist = {
    "": "supplier return supervision",
    view: "supplier return detail",
    add: "add supplier return",
}

export default en_trans_returnsuplist;